module.exports = __webpack_public_path__ + "img/1761987641978-fY3XYAZe.0964688b.png";